import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const existingTagsItemHeight = 2.5;

const ExistingTagsItemBase = styled(Box)({
	display: 'flex',
	padding: '0.5rem 0.75rem',
	justifyContent: 'space-between',
	alignSelf: 'stretch',
	maxHeight: `${existingTagsItemHeight}rem`,
	height: 'inherit'
});

export default ExistingTagsItemBase;
